// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"co-z","badgeLink":"do-z","category":"eo-z"};